module.exports = __webpack_public_path__ + "media/taiwanNo1.67cdcb9f.mp4";